module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "figa"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ack-title1"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "bor"
  }, [_c('p', {
    staticClass: "ext"
  }, [_c('i', [_vm._v("Twinkle, twinkle, little star,"), _c('br'), _vm._v("How I wonder what you are,"), _c('br'), _vm._v("Up above the world so high,"), _c('br'), _vm._v("Like a diamond in the sky,"), _c('br'), _vm._v("Twinkle, twinkle, little star.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("—Jane Taylor, 1824")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("H")]), _vm._v("ow many stars can there be in the universe? For centuries scientists have admired and studied stars. Poets and writers have tried to capture their essence in a single line or two. Many children have wished upon the first evening star, while women and men can even boast drifting through space among them. Throughout time people have loved and celebrated stars. Stars remind us of the vastness of our universe and of what is possible if we learn to reach for our stars.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As quiltmakers we continue to carry out this celebration of stars in our quilts. Whether they are the primary component or a subtle surprise, stars appeal to both the traditional and innovative quiltmaker. As my friend Bernice McCoy Stone would say, “They have stood the test of time.” We never tire of looking at or playing with stars.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("What is learned from star making affects all other avenues of quiltmaking. "), _c('i', [_vm._v("Simply Stars")]), _vm._v(" teaches you how to make stunning star quilts by applying foolproof techniques to exciting fabric combinations. With just a few simple guidelines you will achieve dynamic results.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When I started teaching stars, my star class focused primarily on the technical (piecing) aspects of star making. But as the class began to develop, it took on a life of its own (just as our quilts do)! I found students were willing to experiment with unusual and exciting fabric combinations, making each successive star more elaborate and interesting than the one before. Every star block became an opportunity to try different color and fabric possibilities. Even simple stars in delightful colors and fabrics produced dramatic quilts.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As your interest in star quilts grows, you will find the number of star patterns endless. In an effort to provide a solid base of understanding, "), _c('i', [_vm._v("Simply Stars")]), _vm._v(" is designed to examine stars composed of four basic shapes: squares, rectangles, triangles, and diamonds. With the information covered in this book you will learn techniques that carry over into many different areas of quiltmaking, and are paramount to successful quiltmaking regardless of the patterns used. Following are the types of stars included in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("♦")]), _vm._v("Stars Made of Squares and Triangles")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("♦")]), _vm._v("Stars Made of an Isosceles Triangle in a Square")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("♦")]), _vm._v("Stars Made of Diamonds and Y Seams")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Each star shape is represented with several different six inch and twelve inch blocks along with twelve specific quilt projects. Each block and project is complete with cutting numbers (or patterns) and piecing instructions. I recommend you begin your star journey in the beginning of this book, as the stars are presented in order of difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As a celebration of students work, the Star Gallery explores many creative avenues of star making and quilt design. For their quilts the students combined many of the traditional stars presented in the twelve different quilt projects included in this book. Note how the students combined interesting fabric and design elements in their star quilts. I thank my friends for generously sharing their work with us.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Be prepared for an inspirational adventure into star making. This journey will take you in wonderful new directions. May all your precious stars shine bright!")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('b', [_vm._v("Magic (Cutting) Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The star quilts in this book are based on four basic shapes: squares, rectangles, triangles, and diamonds. These quilts already include magic (cutting) numbers used for rotary cutting. You will find rotary cutting saves times and is extremely accurate.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("If you want to change the size of the block, use the magic (cutting) numbers. These numbers remain constant no matter what size block you are making. There are two basic rules for using the magic (cutting) numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_c('b', [_vm._v("1")]), _vm._v(". The magic (cutting) numbers given will only work with a ¼\" seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_c('b', [_vm._v("2")]), _vm._v(". Measure the finished size of the desired piece and add the magic number to that size.")]), _vm._v(" "), _c('p', {
    staticClass: "num1"
  }, [_vm._v("Do not take into consideration the ¼\" seam allowance; the magic number does that for you.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('b', [_vm._v("SQUARES AND RECTANGLES")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Measure the finished size of the desired piece and add ½\".")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('b', [_vm._v("TRIANGLES")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Triangles can be a little tricky. First you must decide if you want a half-square triangle or a quarter-square triangle.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The difference between the two triangles is where the straight of the grain ends up. The half-square triangle has the two sides adjacent to the 90° corner on the straight of grain. The quarter-square triangle has one side opposite the 90° angle on the straight of grain. You always want the outside edge of the pieced unit or block to remain on the straight of grain. (If not, your block will stretch and become unusable).")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('b', [_vm._v("Half-Square Triangle")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut a square the finished size plus ⅞\", then cut "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "",
      "src": "images/sym.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('b', [_vm._v("Quarter-Square Triangle")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut a square the finished size plus 1¼\", then cut "), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "",
      "src": "images/sym1.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "H3"
  }, [_c('b', [_vm._v("Isosceles Triangle in a Square")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The isosceles triangle in a square is a simple shape to cut. Keep in mind that the star tip has a left and a right, much like a vest or blouse. You must always cut the star tips in double layers, "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("keeping like sides together. This will give you a left and a right. (This is my method, but there are other reliable methods that use templates or rotary cutting techniques.)")]), _vm._v(" "), _c('p', {
    staticClass: "txt1t"
  }, [_vm._v("A: STAR TIP")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut one strip the finished width plus ¾\". Then fold lengthwise and cut a rectangle the finished length plus 1¼\". Cut the rectangle corner to corner. This will give you two left and two right star tips.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt1t"
  }, [_vm._v("B: BACKGROUND")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut a square the finished size plus ⅞\", then cut as shown.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("If all your B triangles are from the same fabric, cut a strip the finished size plus ⅞\", then cut as shown.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('b', [_vm._v("45° DIAMONDS")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When working with a diamond, measure the distance between the parallel lines and add ½\". This is unlike the previous measurements we have taken where we measured the edge of the shape.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("To achieve the 45° cut, use a ruler with a 45° line marked. I recommend the Omnigrid"), _c('sup', [_vm._v("®")]), _vm._v(" rulers, especially the 6\" × 12\" ruler.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut the strip the appropriate width. Then position the strip and ruler as shown.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Cut the initial 45° cut. Slide your ruler across the cut strip to the appropriate measurement, keeping the 45° line on the edge of the strip. Remember you are measuring the width between the parallel lines.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Note: If the diamond is elongated, the pieced diamond unit will have a left and a right side. Cut a strip the finished width plus ½\" by the full width of fabric. Fold the strip lengthwise and cut 45°. Move the ruler and make the second cut.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353926f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_intro.vue
// module id = 69
// module chunks = 0